// src/context/LanguageContext.js
// Context pour gérer la langue - NE PAS MODIFIER

import React, { createContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || 'fr');

  // Sauvegarder la langue en localStorage
  useEffect(() => {
    localStorage.setItem('fynho_language', language);
  }, [language]);

  // Charger la langue depuis localStorage au montage
  useEffect(() => {
    const saved = localStorage.getItem('fynho_language');
    if (saved && saved !== language) {
      setLanguage(saved);
      i18n.changeLanguage(saved);
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  const value = {
    language,
    changeLanguage,
    isEnglish: language === 'en',
    isFrench: language === 'fr',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};